import { provideHttpClient } from '@angular/common/http';
import type { ApplicationConfig } from '@angular/core';
import { inject, isDevMode, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import {
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
    withViewTransitions,
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimusRxDB } from '@animus/utility/web/persistence-rxdb';
import { ServiceWorkerUpdateService } from '@animus/utility/web/service-worker';
import { provideSpartanHlm } from '@spartan-ng/helm/utils';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { cleanupLegacyStorage } from './legacy-storage-cleanup';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(
            appRoutes,
            withInMemoryScrolling({
                // Scroll to URL fragments (e.g. #section) on navigation.
                anchorScrolling: 'enabled',
                // Restore scroll position when navigating back/forward; new forward navigations scroll to top.
                scrollPositionRestoration: 'enabled',
            }),
            withViewTransitions(),
            withComponentInputBinding()
        ),
        provideSpartanHlm(),
        provideHttpClient(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
        provideAppInitializer(() => cleanupLegacyStorage()),
        // Eagerly construct so its update-polling schedule starts at boot rather than on first injection.
        provideAppInitializer(() => {
            inject(ServiceWorkerUpdateService);
        }),
        provideAnimusRxDB({ signalingUrl: environment.webrtcSignalingUrl }),
    ],
};
